(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["polevento-bundles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('polevento-bundles')) {
    customElements.define('polevento-bundles', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.scope = this.closest('product-info') || this.closest('section');
        this.format = new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        this.preferences = { warranty: false, shipping: false };
        this.addEventListener('change', event => {
          if (event.target.dataset.extra) this.preferences[event.target.dataset.extra] = event.target.checked;
          this.refresh();
        });
        this.submitHandler = event => {
          if (event.target.tagName !== 'FORM') return;
          const id = event.target.querySelector('[name="id"]');
          if (!id || id.value !== this.dataset.variant) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.submit(event.target);
        };
        this.scope.addEventListener('submit', this.submitHandler, true);
        this.refresh();
      }
      disconnectedCallback() { this.scope?.removeEventListener('submit', this.submitHandler, true); this.ready = false; }
      get quantity() { return Number(this.querySelector('.pv-packs input[type="radio"]:checked')?.value || 2); }
      packTotal(quantity) {
        const option = this.querySelector('.pv-packs input[type="radio"][value="' + quantity + '"]');
        const price = Number(option?.dataset.packPrice);
        return Number.isFinite(price) && price > 0 ? price : Number(this.dataset.price) * quantity;
      }
      refresh() {
        const selected = this.querySelector('.pv-packs input[type="radio"]:checked');
        const slot = selected?.closest('.pv-pack').querySelector('.pv-pack-extras');
        const extras = this.querySelector('.pv-extras');
        if (slot && extras && extras.parentElement !== slot) slot.append(extras);
        const free = this.quantity >= 2;
        let total = this.packTotal(this.quantity);
        this.querySelectorAll('[data-extra]').forEach(input => {
          const key = input.dataset.extra;
          input.checked = free || this.preferences[key];
          input.disabled = free;
          const price = Number(this.dataset[key + 'Price']);
          const display = this.querySelector('[data-price-for="' + key + '"]');
          display.textContent = free ? this.dataset.free : '+' + this.format.format(price / 100);
          display.classList.toggle('is-free', free);
          if (!free && input.checked) total += price;
        });
        this.querySelectorAll('.pv-pack').forEach(pack => {
          const radio = pack.querySelector('input[type="radio"]');
          const price = radio.checked ? total : this.packTotal(Number(radio.value));
          pack.querySelector('.pv-pack-price strong').textContent = this.format.format(price / 100);
        });
      }
      async submit(form, destination = 'cart', trigger = null) {
        if (this.busy) return;
        this.busy = true;
        const button = trigger || form.querySelector('[type="submit"]');
        const error = this.querySelector('[data-pv-error]');
        error.hidden = true;
        if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
        const root = window.Shopify?.routes?.root || '/';
        try {
          const response = await fetch(root + 'cart.js');
          if (!response.ok) throw new Error(this.dataset.error);
          const cart = await response.json();
          const existing = cart.items.filter(item => String(item.variant_id) === this.dataset.variant).reduce((sum, item) => sum + item.quantity, 0);
          const free = existing + this.quantity >= 2;
          const items = [{ id: this.dataset.variant, quantity: this.quantity }];
          this.querySelectorAll('[data-extra]').forEach(input => {
            const id = this.dataset[input.dataset.extra];
            if (!id || (!free && !input.checked)) return;
            if (!cart.items.some(item => String(item.variant_id) === id)) items.push({ id, quantity: 1, properties: { _polevento_extra: free ? 'gift' : 'selected' } });
          });
          const added = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
          const data = await added.json();
          if (!added.ok || data.status) throw new Error(data.description || this.dataset.error);
          window.location.assign(root + (destination === 'checkout' ? 'checkout?payment=shop_pay' : 'cart'));
        } catch (failure) {
          error.textContent = failure.message || this.dataset.error;
          error.hidden = false;
          if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
          this.busy = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["polevento-cart-sync"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('polevento-cart-sync')) customElements.define('polevento-cart-sync', class extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.calendar || this.ready) return;
      this.ready = true;
      this.root = window.Shopify?.routes?.root || '/';
      if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) this.sync().catch(() => {});
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.sync().catch(() => {}));
      this.checkoutHandler = async event => {
        const target = event.target.closest('[name="checkout"],a[href="/checkout"]');
        if (!target || this.safeCheckout) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        target.setAttribute('aria-busy', 'true');
        try { await this.sync(); this.safeCheckout = true; target.click(); }
        catch { window.location.assign(this.root + 'cart'); }
        finally { target.removeAttribute('aria-busy'); }
      };
      document.addEventListener('click', this.checkoutHandler, true);
    }
    disconnectedCallback() { this.unsubscribe?.(); document.removeEventListener('click', this.checkoutHandler, true); }
    async sync() {
      if (this.pending) return this.pending;
      this.pending = this.reconcile();
      try { return await this.pending; } finally { this.pending = null; }
    }
    async reconcile() {
      const result = await fetch(this.root + 'cart.js');
      if (!result.ok) throw new Error('Cart unavailable');
      const cart = await result.json();
      const count = cart.items.filter(item => String(item.variant_id) === this.dataset.calendar).reduce((sum, item) => sum + item.quantity, 0);
      const updates = {};
      cart.items.forEach(item => {
        const isExtra = [this.dataset.warranty, this.dataset.shipping].includes(String(item.variant_id));
        if (isExtra && item.properties?._polevento_extra === 'gift' && count < 2) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) return;
      const updated = await fetch(this.root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
      if (!updated.ok) throw new Error('Cart update failed');
      if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) window.location.reload();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-player"] && !Shopify.designMode) return;
  try {
    (() => {
  const seen = new WeakSet();
  const loadVideo = (video) => {
    if (video.dataset.pvLoaded === 'true') return;
    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.pvLoaded = 'true';
    video.load();
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach(({ target: video, isIntersecting }) => {
      if (isIntersecting) {
        loadVideo(video);
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.play().catch(() => {});
        }
      } else {
        video.pause();
      }
    });
  }, { rootMargin: '150px 0px', threshold: 0.1 }) : null;
  const register = (root) => {
    const videos = [];
    if (root.matches?.('video[data-pv-lazy]')) videos.push(root);
    root.querySelectorAll?.('video[data-pv-lazy]').forEach((video) => videos.push(video));
    videos.forEach((video) => {
      if (seen.has(video)) return;
      seen.add(video);
      if (observer) observer.observe(video);
      else loadVideo(video);
      video.addEventListener('pointerdown', () => loadVideo(video), { once: true });
    });
  };
  register(document);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node.nodeType === 1) register(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

})();
